export default __webpack_public_path__ + "static/whitelabel_homeSVG2-0f0f06af9f3ecfd5b3d330a2fc0b4bee.svg";